import React from 'react'

function IconReportAudienceTrend() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="101"
      height="100"
      fill="none"
      viewBox="0 0 101 100"
    >
      <rect width="84" height="84" x="16.07" fill="#ECF3EE" rx="22.857"></rect>
      <path
        fill="#E8916F"
        d="M63.652 58.755c0 2.432-1.391 4.404-3.106 4.404-1.716 0-2.712-2.264-2.712-4.697 0-2.432.996-4.111 2.712-4.111 1.715 0 3.106 1.971 3.106 4.404z"
      ></path>
      <path
        fill="#D98868"
        d="M83.182 58.755c0 2.432 1.391 4.404 3.106 4.404 1.716 0 2.712-2.264 2.712-4.697 0-2.432-.996-4.111-2.712-4.111-1.716 0-3.106 1.971-3.106 4.404zM70.25 72.407h6.334v10.677H70.25V72.407z"
      ></path>
      <path
        fill="#EBAD88"
        d="M62.014 62.825v-9.004c0-6.246 4.814-11.31 10.753-11.31h1.3c5.938 0 10.752 5.064 10.752 11.31v9.004c0 6.618-5.101 11.984-11.393 11.984h-.019c-6.291 0-11.393-5.366-11.393-11.984z"
      ></path>
      <path
        fill="#E8916F"
        d="M74.058 42.512h-1.283c-.426 0-.846.029-1.259.08 5.35.657 9.502 5.444 9.502 11.255v8.95c0 5.952-4.109 10.892-9.502 11.845.618.109 1.253.167 1.9.167 6.298 0 11.403-5.378 11.403-12.012v-8.95c0-6.26-4.818-11.335-10.76-11.335z"
      ></path>
      <path
        fill="#5BAC4D"
        d="M88.24 90.973v1.523c0 .405-.312.732-.695.732H59.29c-.384 0-.696-.327-.696-.732v-1.523c0-6.559 4.385-11.875 9.794-11.875h10.059c5.409 0 9.793 5.316 9.793 11.875z"
      ></path>
      <path
        fill="#427C37"
        d="M78.447 79.098h-5.374c5.409 0 9.794 5.316 9.794 11.875v2.255h4.678c.383 0 .695-.327.695-.732v-1.523c0-6.559-4.384-11.875-9.793-11.875z"
      ></path>
      <path fill="#ECF3EE" d="M68.669 79.098h9.495l-4.747 14.13-4.748-14.13z"></path>
      <path
        fill="#96CA8D"
        d="M73.417 93.229l-3.36-14.89a.519.519 0 00-.678-.392l-2.802 1.022a.73.73 0 00-.474.693v5.186c0 .14.05.275.142.376l7.172 8.005zM73.417 93.229l3.36-14.89a.519.519 0 01.678-.392l2.802 1.022c.283.1.473.379.473.693v5.186a.56.56 0 01-.142.376l-7.171 8.005z"
      ></path>
      <path
        fill="#FFD659"
        d="M61.966 56.246s.948.404 1.922-1.521c1.114-2.201 4.049-3.43 7.566-3.296 4.06.154 5.894-1.235 6.829-2.738a.17.17 0 01.311.04c1.19 3.728 2.806 2.81 3.867 6.257.629 2.04 2.277 1.258 2.277 1.258s4.537-2.77 2.2-7.17c.4-8.842-6.181-9.366-6.181-9.366s-3.009-4.024-11.255-1.93c-11.9 3.02-9.787 11.828-9.787 11.828s-2.046 4.173 2.25 6.638z"
      ></path>
      <path
        fill="#FFBD54"
        d="M86.937 49.076c.402-8.841-6.18-9.365-6.18-9.365s-2.61-3.486-9.625-2.278c1.507.32 2.567.887 3.253 1.374a9.718 9.718 0 002.341 1.23c1.903.687 5.122 2.776 4.837 9.039.925 1.74.773 3.224.254 4.384.23.397.447.886.644 1.528.63 2.04 2.278 1.258 2.278 1.258s4.536-2.77 2.198-7.17z"
      ></path>
      <path fill="#D98868" d="M12.396 72.407h6.335v10.677h-6.335V72.407z"></path>
      <path
        fill="#EBAD88"
        d="M4.161 62.825v-9.004c0-6.246 4.814-11.31 10.752-11.31h1.3c5.939 0 10.752 5.064 10.752 11.31v9.004c0 6.618-5.1 11.984-11.393 11.984h-.018c-6.292 0-11.393-5.366-11.393-11.984z"
      ></path>
      <path
        fill="#E8916F"
        d="M16.205 42.512H14.92c-.426 0-.845.029-1.258.08 5.349.657 9.501 5.444 9.501 11.255v8.95c0 5.952-4.109 10.892-9.501 11.845a10.9 10.9 0 001.9.167c6.297 0 11.402-5.378 11.402-12.012v-8.95c0-6.26-4.818-11.335-10.76-11.335z"
      ></path>
      <path
        fill="#0CB2B2"
        d="M30.386 90.973v1.523c0 .405-.311.732-.696.732H1.435c-.383 0-.695-.327-.695-.732v-1.523c0-6.559 4.385-11.875 9.794-11.875h10.058c5.409 0 9.794 5.316 9.794 11.875z"
      ></path>
      <path
        fill="#098080"
        d="M20.592 79.098h-5.374c5.41 0 9.794 5.316 9.794 11.875v2.255h4.678c.384 0 .695-.327.695-.732v-1.523c0-6.559-4.384-11.875-9.793-11.875z"
      ></path>
      <path fill="#ECF9F9" d="M10.815 79.098h9.496l-4.748 14.13-4.748-14.13z"></path>
      <path
        fill="#63CECE"
        d="M15.563 93.23l-3.361-14.897a.519.519 0 00-.674-.393l-2.805.992a.729.729 0 00-.474.693v5.224c0 .14.05.274.142.376l7.171 8.005zM15.563 93.23l3.36-14.897a.519.519 0 01.674-.393l2.806.992c.283.1.474.38.474.693v5.224c0 .14-.051.274-.142.376l-7.172 8.005z"
      ></path>
      <path
        fill="#FFD659"
        d="M17.768 48.358s-6.656 3.148-8.954 7.213c-3.02 5.342-3.101 10.85-4.594 16.103a.343.343 0 01-.628.093C2.569 70.084.5 65.433.5 60.5c0-26.38 17.817-23.282 18.636-21.277 3.698-1.629 11.114 1.737 11.114 17.19 0 7.444-.798 12.568-2.955 15.853a.343.343 0 01-.627-.126c-.416-1.964-1.5-7.322-2.018-12.067-1.185-10.88-6.882-11.715-6.882-11.715z"
      ></path>
      <path
        fill="#FFBD54"
        d="M19.136 39.222c-.33-.807-3.502-1.807-7.172-.99.65.166 1.14.592 1.741 1.718.802 1.5 1.999 2.735 3.484 3.456 3.995 1.94 6.513 5.989 7.712 13.006.283 1.657-.042 3.247-.13 4.699.55 4.465 1.512 9.207 1.897 11.028.066.312.454.39.627.127 2.157-3.286 2.955-8.41 2.955-15.854 0-15.453-7.416-18.819-11.114-17.19z"
      ></path>
      <path
        fill="#E8916F"
        d="M30.684 51.414c0 3.428-1.966 6.207-4.391 6.207S22.459 54.43 22.459 51c0-3.427 1.409-5.794 3.834-5.794s4.39 2.779 4.39 6.207z"
      ></path>
      <path
        fill="#D98868"
        d="M58.296 51.414c0 3.428 1.966 6.207 4.39 6.207 2.426 0 3.834-3.191 3.834-6.62 0-3.427-1.408-5.794-3.833-5.794-2.425 0-4.391 2.779-4.391 6.207zM40.012 70.657h8.956v15.048h-8.956V70.657z"
      ></path>
      <path
        fill="#EBAD88"
        d="M28.37 57.1V44.512c0-8.831 6.806-15.989 15.201-15.989h1.838c8.396 0 15.202 7.158 15.202 15.989V57.1c0 9.357-7.212 16.942-16.108 16.942h-.025c-8.897 0-16.108-7.585-16.108-16.942z"
      ></path>
      <path
        fill="#E8916F"
        d="M45.398 28.523h-1.815c-.602 0-1.195.041-1.78.113 7.564.926 13.434 7.673 13.434 15.863v12.615c0 8.387-5.81 15.35-13.434 16.693.875.154 1.772.235 2.687.235 8.904 0 16.12-7.579 16.12-16.928V44.499c0-8.823-6.81-15.976-15.212-15.976z"
      ></path>
      <path
        fill="#A40965"
        d="M65.447 96.82v2.082c0 .606-.468 1.097-1.043 1.097H24.577c-.576 0-1.043-.49-1.043-1.097V96.82c0-9.242 6.199-16.735 13.846-16.735H51.6c7.648 0 13.847 7.493 13.847 16.735z"
      ></path>
      <path
        fill="#760649"
        d="M51.6 80.085h-5.373c7.647 0 13.846 7.493 13.846 16.735V100h4.33c.577 0 1.043-.492 1.043-1.098V96.82c0-9.242-6.198-16.735-13.846-16.735z"
      ></path>
      <path fill="#F6EFF3" d="M37.777 80.085h13.425L44.49 99.999l-6.713-19.914z"></path>
      <path
        fill="#D98868"
        d="M52.239 59.59c-.667-.286-1.428.052-1.7.753-.012.033-1.314 3.261-5.889 3.261-4.551 0-6.172-3.195-6.25-3.355-.32-.674-1.097-.951-1.74-.62-.648.332-.916 1.153-.6 1.834.093.2 2.343 4.884 8.59 4.884 6.31 0 8.227-4.767 8.305-4.97.271-.701-.05-1.501-.716-1.787zM54.557 48.746c-.132-.033-3.285-.807-7.012.587-.678.254-1.033 1.038-.792 1.752.19.561.693.912 1.229.912.145 0 .293-.026.437-.08 2.964-1.109 5.506-.51 5.527-.504.7.178 1.404-.275 1.573-1.012.169-.736-.262-1.477-.962-1.655zM40.56 51.917c.145.054.292.08.436.08.537 0 1.04-.35 1.23-.912.24-.714-.114-1.498-.792-1.752-3.727-1.394-6.88-.62-7.012-.587-.698.177-1.126.914-.96 1.649.165.735.867 1.19 1.566 1.02.026-.007 2.568-.607 5.532.502z"
      ></path>
      <path
        fill="#C5629C"
        d="M44.49 99.998l-4.806-21.235a.519.519 0 00-.673-.393l-4.387 1.547a.729.729 0 00-.475.694v7.603c0 .175.08.341.216.444l2.19 1.667a.56.56 0 01.215.444v3.057c0 .176.08.341.215.444l7.505 5.728z"
      ></path>
      <path
        fill="#C5629C"
        d="M44.49 99.998l4.806-21.235a.519.519 0 01.673-.393l4.387 1.547c.283.1.474.379.474.694v7.603c0 .175-.08.341-.216.444l-2.189 1.667a.56.56 0 00-.215.444v3.057c0 .176-.08.341-.215.444l-7.505 5.728z"
      ></path>
      <path
        fill="#8C4A37"
        d="M28.3 47.878s1.341.568 2.718-2.145c1.575-3.102 5.724-4.834 10.697-4.645 5.86.222 8.44-1.824 9.735-3.993a.17.17 0 01.311.04c1.688 5.43 4 4.065 5.515 8.968.889 2.877 3.22 1.775 3.22 1.775s6.414-3.905 3.108-10.106c.568-12.462-8.738-13.2-8.738-13.2s-4.253-5.672-15.912-2.721C22.13 26.108 25.117 38.522 25.117 38.522s-2.893 5.88 3.183 9.356z"
      ></path>
      <path
        fill="#804231"
        d="M63.604 37.772c.568-12.462-8.738-13.2-8.738-13.2S51.48 20.058 42.47 21.18c5.02.724 7.022 3.393 7.022 3.393s9.306.738 8.738 13.2c1.949 3.655.52 6.513-.982 8.243.01.03.019.058.027.088.89 2.877 3.22 1.775 3.22 1.775s6.414-3.905 3.109-10.106z"
      ></path>
    </svg>
  )
}

export default IconReportAudienceTrend
